module.exports = __webpack_public_path__ + "static/media/logística-inversa-3.0ebb5cb2.jpg";